<!-- 账号管理 -->
<template>
    <div class='container containerBox'>
        <div class="handle-box" style="margin-bottom:10px;">
            <!-- <el-input v-model="select_word" placeholder="请输入用户名" clearable class="handle-input mr10"></el-input>
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
             -->
            <el-button type="primary" size="medium" v-if="activeName2=='first'" icon="el-icon-plus" @click="addRole(3)">新增公司</el-button>
            <el-button type="primary" size="medium" v-else icon="el-icon-plus" @click="addRole(2)">新增工程师</el-button>
        </div>
        <el-tabs v-model="activeName2" type="card">
            <el-tab-pane label="公司账号" name="first">
                <!-- <el-table :data="accountList" stripe class="table" ref="multipleTable">
                    
                    <el-table-column prop="Username" label="登录账号">
                    </el-table-column>
                    <el-table-column prop="Mobile" label="联系方式">
                    </el-table-column>
                    <el-table-column prop="Name" label="姓名">
                    </el-table-column>
                    <el-table-column prop="User" label="公司名称">
                    </el-table-column>
                    <el-table-column prop="Enable" label="使用状态" sortable>
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.Enable ? 'success': 'danger'">{{scope.row.Enable ? "可用" : "禁用"}}</el-tag>
                        </template>   
                    </el-table-column>
                    <el-table-column prop="Description" label="备注">
                    </el-table-column>
                    <el-table-column label="操作" width="180" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
                            <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table> -->
            </el-tab-pane>
            <el-tab-pane label="工程师账号" name="second">
                <!-- <el-table :data="testAccountList" stripe class="table" ref="multipleTable">
                    <el-table-column prop="Username" label="登录账号">
                    </el-table-column>
                    <el-table-column prop="Mobile" label="联系方式">
                    </el-table-column>
                    <el-table-column prop="Name" label="姓名">
                    </el-table-column>
                    <el-table-column prop="User" label="公司名称">
                    </el-table-column>
                    <el-table-column prop="Enable" label="使用状态" sortable>
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.Enable ? 'success': 'danger'">{{scope.row.Enable ? "可用" : "禁用"}}</el-tag>
                        </template>   
                    </el-table-column>
                    <el-table-column prop="Description" label="备注">
                    </el-table-column>
                    <el-table-column label="操作" width="180" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
                            <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table> -->
            </el-tab-pane>
            
        </el-tabs>
        <l-table
            :list="list"
            :total="total" 
            :otherHeight="292"
            :options="options"
            :pagination="pagination"
            :columns="columns" 
            :operates="operates"
            @handleSizeChange="handleSizeChange"
            @handleIndexChange="handleIndexChange">
        </l-table>

        <!-- 编辑框 -->
        <el-dialog :title="dialogTitle" :visible.sync="editVisible" width="40%" :before-close="dialogClose">
            <el-form ref="roleForm" class="roleForm" :rules="rules" :model="form" label-width="100px">
                <el-form-item label="账户名称" prop="username">
                    <el-input v-model="form.username" :disabled="!!form.oid"></el-input>
                </el-form-item>
                <el-form-item label="账户密码" prop="password" v-if="!form.oid">
                    <el-input type="password" v-model="form.password"></el-input>
                </el-form-item>
                <el-form-item label="公司名称" prop="user">
                    <el-input v-model="form.user"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="mobile">
                    <el-input v-model="form.mobile"></el-input>
                </el-form-item>
				<el-form-item label="邮箱" prop="email">
				    <el-input v-model="form.email"></el-input>
				</el-form-item>
                <el-form-item label="账户状态" prop="enable">
                    <el-select v-model="form.enable" placeholder="请选择账户状态">
                        <el-option key="1" label="可用" :value="true"></el-option>
                        <el-option key="2" label="禁用" :value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="公司LOGO" prop="company_logo" v-if="activeName2=='first'">
                    <el-upload class="avatar-uploader" 
                        :action="UploadUrl" 
                        :show-file-list="false" 
                        accept="image/*" 
                        :on-success="handleAvatarSuccess" 
                        :on-progress="uploadVideoProcess"
                        :headers="headers"
                        name="image"
                        :before-upload="beforeAvatarUpload" style="text-align: left">
                        <img v-if="!Logo" :src="form.company_logo" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <el-progress v-if="videoUploadPercent>0 && videoUploadPercent<100" type="circle" width="50" :percentage="videoUploadPercent" class="upload-progress"></el-progress>
                    </el-upload>
                </el-form-item>
                <el-form-item label="账户职责">
                    <el-input v-model="form.description"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Service from '@/api/Service'
import {$Alert} from '@/utils/utils'
import Storage from '@/utils/storage'
import config from '@/config'
import lTable from '@/components/lTable/lTable'
import stringUtils from '@/utils/stringUtils'
import { checkPhone, checkEmail } from '@/utils/validator'
const jsSHA = require("jssha");

export default {
    name:  'companymana',
    inject: ["reload"],
    data() {
        //  验证手机号+电话号码
        const checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("电话号码不能为空"));
            } else {
                if (stringUtils(value).isMobilePhone() || stringUtils(value).isTelPhone()) {
                    callback();
                } else {
                     return callback(new Error("电话号码格式有误"));
                }
            }
        };
        return {
            select_word: '',
            accountList: [],
            testAccountList: [],
            total1: 0,
            total2: 0,
            activeName2: "first",
            
            editVisible: false,
            form: {},
            dialogTitle: "添加",

            UploadUrl: config.UPLOAD_URL,
            videoUploadPercent: 0,
            Logo: true,

            // 编辑框验证规则
            rules: {
                username: [
                    {
                        required: true,
                        message: "请输入账户名称",
                        trigger: "blur"
                    }
                ],
                password: [
                    {
                        required: true,
                        message: "请输入账户密码",
                        trigger: "blur"
                    }
                ],
                user: [
                    {
                        required: true,
                        message: "请输入公司名称",
                        trigger: "blur"
                    }
                ],
                name: [
                    {
                        required: true,
                        message: "请输入使用者姓名",
                        trigger: "blur"
                    }
                ],
				email: [
				    { required: true, 
					trigger: "blur", 
					validator: checkEmail 
					}
				],
                mobile: [
                    { required: true, 
					trigger: "blur", 
					validator: checkPhone 
					}
                ],
                enable: [
                    { required: true, message: "请选择账户状态", trigger: "change" }
                ]
            },

            // 表格栏
            // total: 0,
            pagination: {
                page_num: 1,
                page_sum: 10
            },
            columns: [
                {
                    prop: 'username',
                    label: '账户名称',
                    align: 'center',
                },
                {
                    prop: 'mobile',
                    label: '手机号码',
                    align: 'center',
                },
                {
                    prop: 'name',
                    label: '姓名',
                    align: 'center',
                },
                {
                    prop: 'user',
                    label: '公司名称',
                    align: 'center',
                },
                {
                    prop: 'enable',
                    label: '使用状态',
                    align: 'center',
                    sortable: true,
                    render: (h, params) => {
                        return h('el-tag', {
                            props: {type: params.row.enable ? 'success' : 'danger' } // 组件的props
                        }, params.row.enable ? '正常' : '禁用')
                    },
                },
                {
                    prop: 'description',
                    label: '备注',
                    align: 'center',
                    sortable: true,
                },
            ], // 需要展示的列
            operates: {
                width: 180,
                fixed: 'right',
                list: [
                    {
                        label: '修改',
                        type: 'primary',
                        show: (index, row) => {
                            return true
                        },
                        icon: 'el-icon-edit',
                        plain: true,
                        disabled: (index, row) => {
                            return false
                        },
                        method: (index, row) => {
                            this.handleEdit(row)
                        }
                    },
                    {
                        label: '删除',
                        type: 'danger',
                        show: (index, row) => {
                            return true
                        },
                        icon: 'el-icon-delete',
                        plain: true,
                        disabled: (index, row) => {
                            return false
                        },
                        method: (index, row) => {
                            this.handleDelete(row)
                        }
                    },
                ]
            }, // 操作按钮组
            options: {
                stripe: true, // 是否为斑马纹 table
                loading: false, // 是否添加表格loading加载动画
                highlightCurrentRow: true, // 是否支持当前行高亮显示
                mutiSelect: false // 是否支持列表项选中功能
            }, // table 的参数
        };
    },
    computed: {
        list() {
            return this.activeName2 === 'first' ? this.accountList : this.testAccountList;
        },
        total() {
            return this.activeName2 === 'first' ? this.total1 : this.total2;
        },
        headers() {
            let token = Storage.get('token');
            if (token) {
                return { Authorization: token.token };
            }else{
                return {}
            }
        },
    },
    components: { lTable },
    mounted() {},
    async created() {
        await this.getData();
        this.getTestAccoutList();
    },

    methods: {
        // 查询
        search() {

        },
        // 获取账号列表
        async getData() {
            let params = Object.assign({}, this.pagination, {usertype: 3});
            let data = await Service.getAdminAccountList(params)
            if(data) {
                let list = data.list == null ? [] : data.list;
                this.accountList = list;
                this.total1 = data.total;
            }
        },
        async getTestAccoutList() {
            let params = Object.assign({}, this.pagination, {usertype: 2});
            let testData = await Service.getAdminAccountList(params)
            if(testData) {
                let list = testData.list == null ? [] : testData.list;
                this.testAccountList = list;
                this.total2 = testData.total;
            }
        },
        // 切换页码
        handleSizeChange (pagination) {
            this.pagination = pagination
            this.getData()
        },
        // 切换页码
        handleIndexChange (pagination) {
            this.pagination = pagination
            this.getData()
        },
        // 新增公司
        addRole(name) {
            this.dialogTitle = "新增";
            this.editVisible = true;
            this.form = {};
            this.form.usertype = name
        },
        
        dialogClose(done) {
            this.$refs["roleForm"].resetFields();
            this.Logo = true;
            done();
        },
        // 编辑
        handleEdit(row) {
            this.form = {
                username: row.username,
                user: row.user,
                name: row.name,
                mobile: row.mobile,
				email: row.email,
                enable: row.enable,
                description: row.description,
                oid: row.oid,
                usertype: row.usertype,
                company_logo: row.company_logo,
            }
            
            this.Logo = row.company_logo === '';
            this.dialogTitle = "编辑";
            this.editVisible = true;
        },
       
        // 删除
        handleDelete(data) {
            $Alert(`是否确认删除 ${data.username} `).then( async (bool)=>{
                if(bool){
                    let res = await Service.delAccount({oid: data.oid});
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        data.Usertype == 2 ? this.getTestAccoutList(): this.getData();
                    }
                }
           });
        },
        // 新增
        saveEdit() {
            this.$refs["roleForm"].validate(valid => {
                if (valid) {
                    if(this.form.oid) {
                        // 编辑
                        this.editAcount()
                    } else{
                        // 添加
                        this.addAcount()
                    }
                    
                } else {
                    return false;
                }
            });
        },
        async addAcount() {
            // 密码加密
            let shaObj = new jsSHA("SHA-512", "TEXT");
            shaObj.update(this.form.password);
            
            this.form.pwd = shaObj.getHash("HEX");
            // this.form.usertype = 3;

            let data = await Service.AddAccount(this.form);
            if(data) {
                this.$message({
                    type: 'success',
                    message: '操作成功!',
                    duration: 1500,
                });
                this.form.usertype == 2 ? this.getTestAccoutList(): this.getData();
                this.editVisible = false;
            }
        },
        async editAcount() {
            let data = await Service.editAccount(this.form);
            if(data) {
                this.$message({
                    type: 'success',
                    message: '操作成功!',
                    duration: 1500,
                });
                this.form.usertype == 2 ? this.getTestAccoutList(): this.getData();
                this.editVisible = false;
            }
        },
        // 图片上传成功后返回地址
        handleAvatarSuccess(res) {
            this.form.company_logo = config.DEFAULT_FILE_PATH + res.data;
            this.Logo = false;
        },
        uploadVideoProcess(event, file, fileList){
            this.videoUploadPercent = file.percentage.toFixed(0);
        },
        // 上传LOGO
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!");
            }
            return isLt2M;
        },
    }
}

</script>
<style lang='less'>
.upload-progress{
    position: absolute;
    z-index: 99;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
}
.avatar-uploader .el-upload{
    position: relative;
    line-height: 0;
}
.avatar-uploader .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: @primary-color;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
}
.avatar {
    width: 120px;
    height: 120px;
    display: block;
}
</style>